import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { updateApplication } from '../../../actions/applications';
import { getRoute, loading } from '../../../actions/sessions';
import { asyncActions } from '../../../actions/general';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useValidateRoute from '../../../hooks/useValidateRoute';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { restrictedTextYes, restrictedTextNo } from '../../../lib/merchant_restricted_text';
import Error from '../../shared/Error';

export default function StateRestrictedProducts({location}) {
  const dispatch = useDispatch();
  const application = useSessionEntity('application');
  const merchant = useSessionEntity('merchant');
  const [restrictedProducts, sellsRestrictedProducts] = useState(false);

  const isLoading = useSelector(state => state.sessions.get('loading'));

  useRouteStatus(location);

  if (!useValidateRoute({ apply: true, company: true })) return (<></>);

  const save = () => {
    dispatch(loading(true));
    dispatch(asyncActions(
      updateApplication(application.set('sells_restricted_products', restrictedProducts)),
      getRoute()
    ))
    .then(res => dispatch(loading(false)));
  }

  return (
    <div id="content">
      <div className="columns">
        <div className="column has-text-centered">
          <h1 className="is-size-4 has-text-weight-bold">Please Confirm</h1>
        </div>
      </div>

      <Error />

      <div className="columns">
        <div className="column">
          <div className="field">
            <input
              type="radio"
              className="is-checkradio"
              id="sells_restricted_products_no"
              name="sells_restricted_products_no"
              onChange={() => sellsRestrictedProducts(false)}
              value={restrictedProducts}
              checked={!restrictedProducts} />
            <label
              htmlFor="sells_restricted_products_no"
              dangerouslySetInnerHTML={{__html: `${application.company_name} ${restrictedTextNo(merchant)}`}}>
            </label>
          </div>
        </div>
      </div>

      <div className="columns">
        <div className="column">
          <div className="field">
            <input
              type="radio"
              className="is-checkradio"
              id="sells_restricted_products_yes"
              name="sells_restricted_products_yes"
              onChange={() => sellsRestrictedProducts(true)}
              value={restrictedProducts}
              checked={restrictedProducts} />
            <label
              htmlFor="sells_restricted_products_yes"
              dangerouslySetInnerHTML={{__html: `${application.company_name} ${restrictedTextYes(merchant)}`}}>
            </label>
          </div>
        </div>
      </div>

      <div className="columns">
        <div className="column has-text-centered">
          <p>
            I hereby certify, to the best of my knowledge, that the information provided above is complete and correct
          </p>

          <button
            type="submit"
            role="submit"
            disabled={isLoading}
            className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold', {
              'is-loading': isLoading
            })}
            onClick={save}>
              Next
          </button>
        </div>
      </div>
    </div>
  )
}
